$(document).ready(function() {

    // GLOBAL JS FOR LIST-GRID-VIEW PARTIAL COMPONENT

    // Hide non-default view
    $("[id$='-list-view']").each(function() {
        $(this).hide();
    });

    $("[id$='-grid-view']:not(:first)").each(function() {
        var rootStr = $(this).attr("id");
        rootStr = rootStr.replace('-grid-view', '');
        $("#" + rootStr + "-section").removeClass('show');
    });

    // Display view based on view button click
    $("[id$='-list-btn']").click(function() {
        var rootStr = $(this).attr("id");
        rootStr = rootStr.replace('-list-btn', '');

        $("#" + rootStr + "-list-view").show();
        $("#" + rootStr + "-grid-view").hide();

        $("#" + rootStr + "-grid-btn").removeClass('active');
        $("#" + rootStr + "-list-btn").addClass('active');

        $("#" + rootStr + "-grid-btn").attr('aria-pressed', 'false');
        $("#" + rootStr + "-list-btn").attr('aria-pressed', 'true');
    });

    $("[id$='-grid-btn']").click(function() {
        var rootStr = $(this).attr("id");
        rootStr = rootStr.replace('-grid-btn', '');

        $("#" + rootStr + "-grid-view").show();
        $("#" + rootStr + "-list-view").hide();

        $("#" + rootStr + "-list-btn").removeClass('active');
        $("#" + rootStr + "-grid-btn").addClass('active');

        $("#" + rootStr + "-list-btn").attr('aria-pressed', 'false');
        $("#" + rootStr + "-grid-btn").attr('aria-pressed', 'true');
    });

    // Toggle plus/minus on expand/collapse button
    $("[id$='-expand-collapse']").click(function(){
        var icon = $(this).find('.fas');
        var icon_fa_icon = icon.attr('data-icon');

        if ($(this).hasClass('collapsed')) {
            console.log('The element has the class.');
            icon.attr('data-icon', 'plus');
            icon.addClass("fa-plus");
            icon.removeClass("fa-minus");
        } else {
            console.log('The element does not have the class.');
            icon.attr('data-icon', 'minus');
            icon.addClass("fa-minus");
            icon.removeClass("fa-plus");
        }

        var rootStr = $(this).attr("id");
        rootStr = rootStr.replace('-expand-collapse', '');

        var viewStr = $(this).parent().find('.active').attr("id");

        if (viewStr.indexOf("grid") >= 0) {
            // console.log("contains grid");
            $("#" + rootStr + "-grid-view").show();
            $("#" + rootStr + "-list-view").hide();
        } else if (viewStr.indexOf("list") >= 0) {
            // console.log("contains list");
            $("#" + rootStr + "-grid-view").hide();
            $("#" + rootStr + "-list-view").show();
        }
    });

    $("[id$='-expand-collapse']:not(:first)").each(function(){
        var icon = $(this).find('.fas');
        var icon_fa_icon = icon.attr('data-icon');
        icon.attr('data-icon', 'plus');
        icon.addClass("fa-plus");
        icon.removeClass("fa-minus");
    });

    // Remove focus from clicked buttons
    $("[id$='-expand-collapse']").click(function(){
        $(this).blur();
    });

    $("[id$='-list-btn']").click(function(){
        $(this).blur();
    });

    $("[id$='-grid-btn']").click(function(){
        $(this).blur();
    });

});